/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const queryBatchUpload = params => {
  return axios.post(`${base}/excel/query_upload`, params)
}
export const getBatchUpload = params => {
  return axios.get(`${base}/excel/get_${params.id}`)
}
export const downSourceFile = id => {
  return `${base}/excel/down_sourc_file_` + id
}
export const doDownSourceFile = id => {
  return axios.get(downSourceFile(id), { responseType: 'blob' })
}
export const downErrorFile = id => {
  return `${base}/excel/down_error_file_` + id
}
export const downUnprocessFile = id => {
  return `${base}/excel/down_unprocess_file_` + id
}
export const downExportFile = id => {
  return `${base}/excel/down_export_file_${id}`
}
export const downEncryptExportFile = id => {
  return `${base}/batch_jobs/down_encrypt_export_file_${id}.7z`
}
export const downCompleteFile = id => {
  return `${base}/excel/down_complete_file_${id}`
}
export const cancelTaskBatch = params => {
  return axios.post(`${base}/excel/cancel_${params.id}`, params)
}
export const pauseTaskBatch = params => {
  return axios.post(`${base}/excel/pause_${params.id}`, params)
}
export const continueTaskBatch = params => {
  return axios.post(`${base}/excel/continue_${params.id}`, params)
}
export const createTaskBatch = params => {
  return axios.post(`${base}/excel/create_upload`, params)
}
export const createExecuteTaskBatch = params => {
  return axios.post(`${base}/excel/create_execute_upload`, params)
}
export const batchExportCityMaps = params => {
  return axios.post(`${base}/citymap/export`, params)
}




// WEBPACK FOOTER //
// ./src/views/task-batch/task-batch.api.js